import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Navbarnft_global from "./Navbars/Navbarnft_global";
import Footer from "./Footer";
import placeholderImage from "../Images/placeholder.svg";
import gold from "../Images/tick_gold.png";
import blue from "../Images/tick_blue.png";
import { useApiList, collectionLink } from "./exploreData";
import "./ExplorePages.css";

const categories = ["All", "Art", "Gaming", "Membership", "Metaverse", "Utility"];

function ExploreInsidepage({ UserWallet, signMessage, logout }) {
  const [cat, setCat] = useState("All");
  const collections = useApiList("/rank");

  const list = useMemo(
    () =>
      (collections || [])
        .filter((c) => cat === "All" || c.catogry === cat)
        .sort((a, b) => Number(a.rank) - Number(b.rank)),
    [collections, cat]
  );

  return (
    <>
      <Navbarnft_global UserWallet={UserWallet} signMessage={signMessage} logout={logout} URL={window.apiURL} />
      <div className="w3-container">
        <section className="ex-hero">
          <div className="w3-eyebrow">Categories</div>
          <h1>What’s <span className="w3-gradient-text">hot</span> right now</h1>
          <p>The most popular collections, ranked by the PanSea community.</p>
        </section>
        <div className="ex-cats">
          {categories.map((c) => (
            <button key={c} className={`ex-chip ${cat === c ? "is-active" : ""}`} style={{ color: "inherit", cursor: "pointer" }} onClick={() => setCat(c)}>
              {c}
            </button>
          ))}
        </div>
        {collections !== null && list.length === 0 ? (
          <div className="ex-empty">No collections in this category yet.</div>
        ) : (
          <div className="ex-grid">
            {list.map((c) => (
              <Link key={c._id} to={collectionLink(c)} className="ex-card w3-glass">
                <div className="ex-card-img">
                  <img src={c.featureImage || c.logoImage || placeholderImage} alt="" />
                  <span className="ex-badge">#{c.rank}</span>
                </div>
                <div className="ex-card-body">
                  <div className="ex-card-title">
                    {c.name}
                    {c.tick === "gold" && <img src={gold} alt="Sharia compliant" />}
                    {c.tick === "blue" && <img src={blue} alt="Verified" />}
                  </div>
                  <div className="ex-card-sub">{c.catogry}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default ExploreInsidepage;
